import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import SetpointAdministrationService from "../../services/setpoint-administration-service/SetpointAdministrationService";

export type MutationContextType = {
    previous: number[];
};

export type UseLinkSetpointsParameters = {
    groupID: number,
    tagID: number
} & BaseUseMutationParameters<void, number[]>;

export function useLinkSetpoints({
    groupID,
    tagID,
    onError,
    onSuccess
}: UseLinkSetpointsParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, number[], MutationContextType>(
        async (setpoints) => {
            await SetpointAdministrationService.linkTagToSetpoints(
                groupID,
                tagID,
                setpoints
            );
        },
        {
            onMutate: async (item: number[]) => {

                // the only real benefit with this is to get the other queries to refresh
                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                });

                queryClient.refetchQueries({
                    //queryKey: [keys.all],
                    queryKey: ['setpoints', 'groupedsetpoints'],
                    //active: true,
                    //inactive: true
                    //type: 'all'
                });

                return {
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            // onSettled: (_data, error, _configuration, context) => {

            //     // const otherKeys = _configuration.pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ?
            //     // deviceSummaryKeys :
            //     // wellSummaryKeys;                

            //     // if (error && context?.previousConfigurations) {

            //     //     queryClient.setQueryData<PageConfigurationDataModel3>(
            //     //         otherKeys.configurationList(
            //     //             groupID
            //     //         ),
            //     //         context?.previousConfigurations
            //     //     );
            //     // }

            //     // // If there was an error in saving our configuration, such as name in use,
            //     // // then don't invalidate the queries, otherwise the configuration will
            //     // // reload and our changes will be discarded.
            //     // if (!error) {
            //     //     queryClient.invalidateQueries(keys.all);
            //     //     queryClient.invalidateQueries(otherKeys.all);
            //     // }
            // }
        }
    );
}
